import {
  Folder,
  HostedComponent,
  LibraryService,
  PublicComponent,
} from './library_service';

const COMPONENT_THUMBS = [
  {
    thumbnailUrl:
      'https://www.relume.io/__assets/61789b489343c8242282a0ae/618f3e58f5e77db735579b2b_6185051aae290a4064bb3799_footer1_component.png',
    thumbnailWidth: 1400,
    thumbnailHeight: 519,
  },
  {
    thumbnailUrl:
      'https://assets.website-files.com/61789b489343c8242282a0ae/621da33a83229fa5a55441a7_banner7_component-p-500.png',
    thumbnailWidth: 500,
    thumbnailHeight: 25,
  },
  {
    thumbnailUrl:
      'https://assets.website-files.com/61789b489343c8242282a0ae/618f3e5d9ec9d20e1c88c417_6185054ce649965476ca4145_section-header1.png',
    thumbnailWidth: 1400,
    thumbnailHeight: 814,
  },
];

const aFolder: Folder = {
  name: 'Your Library',
  folder_id: 'folder_id_1',
  description: 'A folder description',
  owner_name: 'Folder Owner Name',
  role: 'admin',
};
const somePublicComponents = new Array(10)
  .fill(0)
  .map<PublicComponent>((_, i) => ({
    ...COMPONENT_THUMBS[(i * 1337) % COMPONENT_THUMBS.length],
    from: 'public-library',
    kind: 'component',
    categorySlug: 'banners',
    componentSlug: `banner-${i}`,
    webflowSlug: `banner-${i}`,
    name: `BannerBannerBanner ${i} Name Name Name`,
    lastUsedTime: 1679453315 - 6 * 60 * 60 * i,
    variants: [],
  }));
const someHostedComponents = new Array(10)
  .fill(0)
  .map<HostedComponent>((_, i) => ({
    ...COMPONENT_THUMBS[(i * 1337) % COMPONENT_THUMBS.length],
    from: 'hosted-library',
    id: `${i}`,
    kind: undefined,
    name: `BannerBannerBanner ${i} Name Name Name`,
    lastUsedTime: 1679453315 - 6 * 60 * 60 * i,
  }));
export const aPublicComponent = somePublicComponents[0];

export const fakeEmptyLibraryService: LibraryService = {
  findPublicComponents: async () => ({
    components: [],
  }),
  findPublicCategories: async () => ({
    categories: [
      {
        kind: 'component',
        categorySlug: 'banners',
        name: 'Banners',
        components: [],
      },
      {
        kind: 'ui-element',
        categorySlug: 'buttons',
        name: 'Buttons',
        components: [],
      },
    ],
  }),
  findBlocksCategories: async () => ({
    blocksCategories: [],
    homeTranslations: new Map(),
  }),
  getHostedFolder: async () => ({
    folder: aFolder,
    components: [],
    folders: [],
  }),
  findRecentlyUsedHostedComponents: async () => ({ components: [] }),
  searchHostedLibrary: async () => ({
    folders: [],
    components: [],
  }),
  getLibraryElement: async () => {
    throw new Error('Not implemented');
  },
  listLibraryElements: async () => ({ elements: [] }),
  getElementType: async () => {
    throw new Error('Not implemented');
  },
  listElementTypes: async () => ({ elementTypes: [] }),
  getSlotType: async () => {
    throw new Error('Not implemented');
  },
  listSlotTypes: async () => ({ slotTypes: [] }),
  getPublicComponentJson: async () => {
    throw new Error('Not implemented');
  },
  copyPublicComponent: async () => {
    throw new Error('Not implemented');
  },
  copyHostedComponent: async () => ({}),
};

export const fakeLibraryService: LibraryService = {
  ...fakeEmptyLibraryService,
  findPublicComponents: async () => ({
    components: somePublicComponents,
  }),
  getHostedFolder: async (folder_id) => ({
    folder: {
      ...aFolder,
      name: folder_id == 'inner_folder' ? 'Inner folder' : 'Your Library',
    },
    folders:
      folder_id !== 'inner_folder'
        ? [{ ...aFolder, folder_id: 'inner_folder', name: 'Inner folder' }]
        : [],
    components: someHostedComponents,
  }),
};
